import "../styles/Home.css";
import Header from "../components/Header";
import Marquee from "react-fast-marquee";
import Footer from "../components/Footer";

// Image

import work1 from "../assets/work-1.webp";
import work2 from "../assets/work-2.jpg";
import work3 from "../assets/work-3.webp";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="home">
      <Header />
      <main>
        {/* Sticky Service */}

        <div className="section1">
          <div className="service_holder">
            <div className="container1">
              <h1>digital</h1>
              <h1>
                <span>services</span>
              </h1>
              <span>explore services</span>
            </div>
            <div className="container2">
              <div className="service_box">
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccce43bb2e8ef992914c_icon-05.svg"
                  alt=""
                  className="serv_img"
                />
                <div className="serv_content">
                  <h2>VIDEO CREATION</h2>
                  <p>
                    Dolor magna eget est lorem ipsum dolor sit amet consectetur.
                    Bibendum est ultricies integer quis auctor elit sed. Odio
                    morbi quis commodo odio aenean sed.
                  </p>
                </div>
              </div>
              <div className="service_box">
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccd0cb0557526a50502_icon-06.svg"
                  alt=""
                  className="serv_img"
                />
                <div className="serv_content">
                  <h2>MOTION DESIGN</h2>
                  <p>
                    Dolor magna eget est lorem ipsum dolor sit amet consectetur.
                    Bibendum est ultricies integer quis auctor elit sed. Odio
                    morbi quis commodo odio aenean sed.
                  </p>
                </div>
              </div>
              <div className="service_box">
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccdfcf5e03648524608_icon-07.svg"
                  alt=""
                  className="serv_img"
                />
                <div className="serv_content">
                  <h2>ART DIRECTION</h2>
                  <p>
                    Dolor magna eget est lorem ipsum dolor sit amet consectetur.
                    Bibendum est ultricies integer quis auctor elit sed. Odio
                    morbi quis commodo odio aenean sed.
                  </p>
                </div>
              </div>
              <div className="service_box">
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccefd8379566976da54_icon-08.svg"
                  alt=""
                  className="serv_img"
                />
                <div className="serv_content">
                  <h2>SOCIAL MEDIA</h2>
                  <p>
                    Dolor magna eget est lorem ipsum dolor sit amet consectetur.
                    Bibendum est ultricies integer quis auctor elit sed. Odio
                    morbi quis commodo odio aenean sed.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Marquee Text */}

        <Marquee speed={90}>
          <h1 className="marquee_work">
            <span>&nbsp; selected work </span> selected work{" "}
            <span> selected work </span> selected work{" "}
          </h1>
        </Marquee>

        {/* Work */}

        <div className="work_container">
          <div className="img_box">
            <img src={work1} alt="" />
            <div>
              <h1>cyberpunk</h1>
              <p>invision studio</p>
            </div>
          </div>

          <div className="img_container2">
            <div className="img_box">
              <img src={work2} alt="" />
              <div>
                <h1>virtual reality</h1>
                <p>vision square</p>
              </div>
            </div>

            <div className="img_box">
              <img src={work3} alt="" />
              <div>
                <h1>digital future</h1>
                <p>motion agency</p>
              </div>
            </div>
          </div>
          <p className="project_text">
            <span><Link to="/projects" onClick={() => {window.top=0}}>see all projects</Link></span>
          </p>
        </div>

        {/* Motion Awards */}

        <div className="award_container">
          <div>
            <h1>
              <span>motion</span>
            </h1>
            <h1>awards</h1>
          </div>
          <div className="award_box">
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccc7d48c9f09c3ea7561_icon-01.svg"
                  alt=""
                />
                <h2>video award</h2>
              </div>
              <span>2022</span>
            </div>
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccd213c113c80ba9c6f_icon-02.svg"
                  alt=""
                />
                <h2>MOTION DESIGNER OF THE YEAR</h2>
              </div>
              <span>2021</span>
            </div>
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccce81a8e677df9db833_icon-03.svg"
                  alt=""
                />
                <h2>VIDEO OF THE MONTH</h2>
              </div>
              <span>2019</span>
            </div>
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccef386b74850e95ae6_icon-04.svg"
                  alt=""
                />
                <h2>ART DIRECTION AWARD</h2>
              </div>
              <span>2018</span>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
